/* eslint-disable */
import * as Types from '../graphql/types.generated';

import { gql } from '@apollo/client';
export type AgentQuoteHeaderFragment = { __typename?: 'Agent', name?: string | null, slug?: string | null, phoneNumber?: string | null, email?: string | null, licensedYear?: number | null, velocifyId?: number | null, sys: { __typename?: 'Sys', id: string }, photo?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null };

export const AgentQuoteHeaderFragmentDoc = gql`
    fragment AgentQuoteHeader on Agent {
  sys {
    id
  }
  name
  slug
  photo {
    description
    url(
      transform: {width: 220, height: 220, resizeStrategy: FILL, resizeFocus: FACE}
    )
    width
    height
  }
  phoneNumber
  email
  licensedYear
  velocifyId
}
    `;